"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.blockRendererFn = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _draftJs = require("draft-js");
var _Media = _interopRequireDefault(require("./Media"));
var _InsertImageButton = _interopRequireDefault(require("./InsertImageButton"));
var _InsertScriptButton = _interopRequireDefault(require("./InsertScriptButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
if (require('exenv').canUseDOM) require('./styles.scss');
class MediaControls extends _react.Component {
  handleInsertMedia(mediaType, source) {
    const _this$props = this.props,
      editorState = _this$props.editorState,
      setEditorState = _this$props.setEditorState;
    const entityKey = _draftJs.Entity.create(mediaType, 'IMMUTABLE', {
      src: source
    });
    const editorStateWithMedia = _draftJs.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
    setEditorState(editorStateWithMedia);
    this.props.focusEditor();
  }
  render() {
    const _this$props2 = this.props,
      buttonClassName = _this$props2.buttonClassName,
      popoverClassName = _this$props2.popoverClassName;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mediaControls"
    }, /*#__PURE__*/_react.default.createElement(_InsertImageButton.default, {
      buttonClassName: buttonClassName,
      popoverClassName: popoverClassName,
      handleUploadFinish: source => this.handleInsertMedia('image', source)
    }), /*#__PURE__*/_react.default.createElement(_InsertScriptButton.default, {
      buttonClassName: buttonClassName,
      popoverClassName: popoverClassName,
      handleInsertScript: this.handleInsertMedia.bind(this)
    }));
  }
}
exports.default = MediaControls;
const blockRendererFn = block => {
  if (block.getType() === 'atomic') {
    return {
      component: _Media.default
    };
  }
};
exports.blockRendererFn = blockRendererFn;